'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _incompletedocumentation = require('./incompletedocumentation.html');

var _incompletedocumentation2 = _interopRequireDefault(_incompletedocumentation);

var _incompletedocumentation3 = require('./incompletedocumentation.controller');

var _incompletedocumentation4 = _interopRequireDefault(_incompletedocumentation3);

require('./incompletedocumentation.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var incompletedocumentationComponent = {
  restrict: 'E',
  bindings: {},
  template: _incompletedocumentation2.default,
  controller: _incompletedocumentation4.default,
  controllerAs: 'vm'
};

exports.default = incompletedocumentationComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/incompletedocumentation/incompletedocumentation.component.js